import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Before & After',
    href: '#before-after'
  }, {
    name: 'Videos',
    href: '#videos'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-primary text-white shadow-lg py-3' : 'bg-transparent text-white py-5'}`} data-id="element-196">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-197">
        <a href="#home" className="font-bold tracking-wider flex items-center gap-2 text-[28px] font-[Merriweather,_serif] text-[#D4A953]" data-id="element-198">
          <img src="https://cdn.magicpatterns.com/uploads/ispNk6VeuXY9oP7XCVrrri/WhatsApp_Image_2026-04-20_at_12.48.43_AM_(2).jpg" alt="WC Home Remodeling Logo" className="h-10 w-auto rounded-sm" data-id="element-199" />
          Home Remodeling
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-200">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium hover:text-accent transition-colors" data-id="element-201">
              {link.name}
            </a>)}
          <a href="#contact" className="bg-accent hover:bg-accent-hover text-white px-6 py-2 rounded-sm font-medium transition-colors flex items-center gap-2" data-id="element-202">
            <Phone size={16} data-id="element-203" />
            Contact
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white hover:text-accent transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-204">
          {isMobileMenuOpen ? <X size={28} data-id="element-205" /> : <Menu size={28} data-id="element-206" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-207">
        {isMobileMenuOpen && <motion.nav initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-primary border-t border-primary-light overflow-hidden" data-id="element-208">
            <div className="flex flex-col px-6 py-4 gap-4" data-id="element-209">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-white hover:text-accent text-lg py-2 border-b border-primary-light" onClick={() => setIsMobileMenuOpen(false)} data-id="element-210">
                  {link.name}
                </a>)}
              <a href="#contact" className="bg-accent text-white px-6 py-3 rounded-sm font-medium text-center mt-2 flex justify-center items-center gap-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-211">
                <Phone size={18} data-id="element-212" />
                Request a Quote
              </a>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}